import React, { JSX, PropsWithChildren } from 'react';
import { Box, Flex } from '@resideo/blueprint-react';
import Footer from 'components/common/Footer';
import { useAuth } from 'utils/auth';
import Header from 'components/common/Header';
import LeftNavigation from 'components/common/LeftNavigation';
import styled from 'styled-components';

const GreyPanel = styled(Box)`
  height: 360px;
  background-color: ${({ theme }) => theme.colors.separator};
`;

type AppLayoutProps = {
  showHeader?: boolean;
  showLeftNav?: boolean;
  showGreyPanel?: boolean;
  showFooter?: boolean;
};

const AppLayout = ({
  showHeader = true,
  showLeftNav = true,
  showGreyPanel = false,
  showFooter = true,
  children,
}: PropsWithChildren<AppLayoutProps>): JSX.Element => {
  const auth = useAuth();
  const isAuthenticated = auth && auth.isAuthenticated && !auth.isLoading;

  return (
    <Flex flexDirection='column' minHeight='100vh'>
      {showHeader && <Header isAuthenticated={isAuthenticated} />}
      <Flex flex='1'>
        {isAuthenticated && showLeftNav && <LeftNavigation />}
        {showGreyPanel ? (
          <Box as='main' role='main' flex='1' backgroundColor='#fff'>
            <GreyPanel>{children}</GreyPanel>
          </Box>
        ) : (
          <Box
            as='main'
            role='main'
            flex='1'
            backgroundColor='#fff'
            paddingTop={['small', 'medium']}>
            {children}
          </Box>
        )}
      </Flex>
      {showFooter && <Footer />}
    </Flex>
  );
};

export default AppLayout;
